module.exports = __webpack_public_path__ + "static/media/team_lunch_response.a1d10187.png";